/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type BabylonBtcStakerListRequest = {
    sortField?: BabylonBtcStakerListRequest.sortField;
    sortDirection?: BabylonBtcStakerListRequest.sortDirection;
    page?: number;
    size?: number;
};

export namespace BabylonBtcStakerListRequest {

    export enum sortField {
        STAKING_VALUE = 'STAKING_VALUE',
        FP_COUNT = 'FP_COUNT',
    }

    export enum sortDirection {
        ASC = 'ASC',
        DESC = 'DESC',
    }


}

